import IncomeTaxForm from './IncomeTax';
import VatTaxForm from './VatTax';
import PaymentForm from './Payment';

export {IncomeTaxForm, VatTaxForm, PaymentForm};
